import React, { useEffect, useState } from 'react';
import FormRadio from './form_elements/form-radio';
import DependentsSelector from './dependents-selector';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { buildDependents, hasQualifiedDependents, isMarried } from './contact-builder';
import { isCourtOrdered } from './is-court-ordered';
import { PlanType } from './enums/plan-type';

const Tiers = ({plan, planOption, setPlanOption, type, reset, setDisabled, disabled}) => {
    const { setValue, getValues,trigger } = useFormContext();
    const [options, setOptions] = useState([]);
    const [dependents, setDependents] = useState([]);
    const enrollments = useSelector((s) => s.enrollments);
    const providerOptionFieldName = "planOption";

    useEffect(() => {
        if (!Array.isArray(enrollments) && enrollments.plans) {
          const deps = buildDependents(enrollments);
          setDependents(deps)
        }
      }, [enrollments, type, reset]);

    useEffect(() => {
        if(!plan)
            return;
        setOptions(buildOptions(plan.options));
        setOption(plan);
        if(!plan || !plan?.options || plan?.options?.length === 0)
            if(setDisabled)
                setDisabled(true);
    
    }, [plan])

    const setOption = (selectedPlan) => {
        let selection = enrollments.selections.find(s => s.planId === selectedPlan.id);
        
        let option = null;
        if (selection){
          option = selection.planOption;
          const planOption = selectedPlan?.options.find(o => o.id === option);
          setPlanOption(planOption);
        } else {
          setPlanOption(null);
        }
    
        setValue(providerOptionFieldName, option);
        trigger(providerOptionFieldName);
    };

      const selectOption = (option) => {
        console.log(plan.options.find(o => o.id === option));
        setPlanOption(plan.options.find(o => o.id === option));
      }
      const buildOptions = (planOptions) => {
        var hasCourtOrdered = false;
        dependents?.forEach(d => {
          if(isCourtOrdered(d.courtOrdered, plan?.planType))
            hasCourtOrdered = true;
            return;
        });
        if(!hasCourtOrdered)
          return planOptions.filter(s => s.id !== "5");
    
        var opts = [];
        opts.forEach(o => {
          if(o.id === "1" || o.id === "3" || o.id === "5" || o.id === "WAIVED")
            o.disabled = true;
          else
            o.disabled = false;
          opts.push(0);
        })
        return opts;
      }
    
      const onDisabled = (plan,option,oldDependents) => {
        const oldPlan = enrollments?.selections?.find(s => s.planType === type)      
        const formDependents = getValues("dependents");
        var truth = true;
    
        for(let i = 0; i < oldDependents.length;i++){
          if(oldDependents[i].enrolled !== formDependents[i].enrolled)
            truth = false;
        }
        if(plan?.planType === PlanType.BasicLife){
          if(option?.id === "2" && (hasQualifiedDependents(enrollments) || isMarried(enrollments))){
            setDisabled(true);
          } else {
            setDisabled(false);
          }
          return;
        }
        if(oldPlan?.planId === plan?.id && oldPlan?.planOption === option?.id && truth){
          setDisabled(true);      
        }
        else {

        }
      }
    
    
    return ( 
        <>
            {plan && plan.options.length > 0 ?
            <>
              <FormRadio label="Select Tier" 
                name={providerOptionFieldName} 
                options={options} 
                itemTextField="label"  
                itemDisabledField="disabled" 
                onChange={selectOption}  
                type={type} 
                disabled={disabled}
                reset={reset} 
                onReset={enrollments?.selections?.find(s => s.planType === type)}/> 
              <div className="my-8">
                <DependentsSelector plan={plan} planOption={planOption} reset={reset} onDisabled={onDisabled}/>
              </div>
            </>  
            : <></>}
        </>
     );
}
 
export default Tiers;